import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import styled from 'styled-components';

// 3rd party
import MenuItem from 'material-ui/MenuItem';

import { SelectField, TextField } from 'redux-form-material-ui';

// components
import Toggle from '../../../../components/Toggle';
import AlertMessage from '../../../../components/AlertMessage';
import FormFooter from '../../../../components/FormFooter';
import CheckboxGroup from '../../components/CheckboxGroup';

// utils + enums
import { required, validEmail } from '../../../../utils/validators';
import {
  PERMISSION_OPTIONS,
  USER_TYPES,
  BRANCHES_OPTIONS_USER,
} from '../../shared/static-options';

// css
import './styles.css';

const UserTypeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ToggleContainer = styled.div`
  margin-right: 48px;
  min-width: 140px;
`;

class PlatformUserForm extends Component {
  _saveUser = (formValues) => {
    const newValues = {
      ...formValues,
      companyId: formValues.companyId && JSON.parse(formValues.companyId),
      divisions: formValues.divisions.toString(),
    };

    this.props.onSubmit(newValues);
  };

  _resetValuesOnCustomerServiceChange = () => {
    const {
      dispatch, change, isCustomerService, userData,
    } = this.props;

    // Set companyID to initialValue if isCustomerService becomes false
    if (isCustomerService && userData !== undefined) {
      dispatch(change('companyId', userData.companyId));
    }

    if (!isCustomerService && userData !== undefined) {
      dispatch(change('companyId', null));
    }
  };

  render() {
    const {
      userData,
      onDismiss,
      onRemove,
      companies,
      errorMessage,
      handleSubmit,
      invalid,
      isCustomerService,
    } = this.props;

    return (
      <form onSubmit={handleSubmit(this._saveUser)}>
        <Field
          name="name"
          floatingLabelText="Nome"
          fullWidth
          component={TextField}
          validate={required}
        />
        <Field
          name="email"
          floatingLabelText="E-mail"
          fullWidth
          component={TextField}
          validate={[required, validEmail]}
        />
        <UserTypeContainer>
          <ToggleContainer>
            <div className="PlatformUserForm__sac-user-container">
              <Field
                name="isCustomerService"
                component={Toggle}
                onChange={this._resetValuesOnCustomerServiceChange}
              />

              <span
                onClick={() => {
                  // Make label clickable
                  const { dispatch, change } = this.props;
                  dispatch(change('isCustomerService', !isCustomerService));

                  // Reset companyId
                  this._resetValuesOnCustomerServiceChange();
                }}
                className="PlatformUserForm__sac-user-container-label"
              >
                Usuário SAC
              </span>
            </div>
          </ToggleContainer>
          <Field
            name="companyId"
            floatingLabelText="Empresa"
            fullWidth
            component={SelectField}
            onChange={(event, index, value) => {
              const { dispatch, change } = this.props;
              dispatch(change('companyId', value));
            }}
            validate={!isCustomerService ? required : null}
            disabled={isCustomerService}
          >
            {companies &&
              companies.map(company => (
                <MenuItem
                  key={company.id}
                  value={JSON.stringify({
                    id: company.id,
                    divisions: company.divisions,
                  })}
                  primaryText={company.name}
                />
              ))}
          </Field>
        </UserTypeContainer>

        {isCustomerService && (
          <Field
            name="divisions"
            props={{
              label: 'Divisão',
              options: BRANCHES_OPTIONS_USER,
            }}
            validate={isCustomerService ? [required] : []}
            component={CheckboxGroup}
          />
        )}

        <Field
          name="roles"
          props={{
            label: 'Configurar permissões',
            options: PERMISSION_OPTIONS,
          }}
          component={CheckboxGroup}
        />
        {errorMessage && <AlertMessage error box message={errorMessage} />}
        <FormFooter
          invalid={invalid}
          entityName="usuário"
          onCancel={onDismiss}
          onRemove={
            onRemove
              ? () => {
                  onRemove(userData);
                }
              : null
          }
        />
      </form>
    );
  }
}

// Redux
const mapStateToProps = (state, ownProps) => {
  const { userData } = ownProps;

  return userData
    ? {
      initialValues: {
        id: userData.id,
        name: userData.name,
        email: userData.email,
        companyId: userData.companyId
          ? JSON.stringify({
            id: userData.companyId,
            divisions: userData.divisions,
          })
          : null,
        roles: userData.roles.map(role => role.id),
        divisions: userData.divisions
          ? userData.divisions.split(',').map(el => parseInt(el, 10))
          : [],
        isCustomerService:
            userData.userType === USER_TYPES.CUSTOMER_SERVICE_USER,
      },
      isCustomerService: formValueSelector('platformUser')(
        state,
        'isCustomerService',
      ),
      companyId: formValueSelector('platformUser')(state, 'companyId'),
    }
    : {
      initialValues: {
        id: '',
        name: '',
        email: '',
        companyId: '',
        roles: [],
        divisions: [BRANCHES_OPTIONS_USER[0].id],
        isCustomerService: false,
      },
      isCustomerService: formValueSelector('platformUser')(
        state,
        'isCustomerService',
      ),
    };
};

export default connect(mapStateToProps)(reduxForm({ form: 'platformUser' })(PlatformUserForm));
